export function wrapToAmericanFormat(date: Date | string) {
  if (!date) return '';
  const valueAsDate = new Date(date);

  return valueAsDate.toISOString().split('T')[0];
}